import { render } from "./generalForm.vue?vue&type=template&id=3f3e6473"
import script from "./generalForm.vue?vue&type=script&lang=js"
export * from "./generalForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__